import React from 'react'
import SEOHead from '../components/shared/SEOHead'
import { getPageSEO } from '../utils/seoConfig'
import Navbar from '../components/shared/Navbar'
import EditProfile from '../components/organization-profile/EditProfile'

const EditOrganizationProfilePage: React.FC = () => {
  return (
    <>
      <SEOHead seo={getPageSEO("editOrganizationProfile")} />
      <Navbar />
      <EditProfile />
    </>
  )
}

export default EditOrganizationProfilePage
